// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-businessServices-services-bsBom2a-Bom2aControl-Bom2aPositions-Bom2aPositionsTable-components-Bom2aColorCell-Bom2aColorCell-module__box--i9cxZ {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3px;
  border: none;
  cursor: pointer;
  height: 100%;
  width: 100%;
  background: none;
}
.src-businessServices-services-bsBom2a-Bom2aControl-Bom2aPositions-Bom2aPositionsTable-components-Bom2aColorCell-Bom2aColorCell-module__box--i9cxZ:disabled {
  cursor: default;
}
.src-businessServices-services-bsBom2a-Bom2aControl-Bom2aPositions-Bom2aPositionsTable-components-Bom2aColorCell-Bom2aColorCell-module__tableBox--qp5nj {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.src-businessServices-services-bsBom2a-Bom2aControl-Bom2aPositions-Bom2aPositionsTable-components-Bom2aColorCell-Bom2aColorCell-module__smallImage--xjVCf {
  max-width: 80px;
  max-height: 60px;
}
.src-businessServices-services-bsBom2a-Bom2aControl-Bom2aPositions-Bom2aPositionsTable-components-Bom2aColorCell-Bom2aColorCell-module__colorBox--D7q8G {
  width: 80px;
  height: 40px;
  border: thin dotted black;
}
`, "",{"version":3,"sources":["webpack://./src/businessServices/services/bsBom2a/Bom2aControl/Bom2aPositions/Bom2aPositionsTable/components/Bom2aColorCell/Bom2aColorCell.module.less"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;EAEA,YAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;AAAF;AACE;EACE,eAAA;AACJ;AAGA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AADF;AAGA;EACE,eAAA;EACA,gBAAA;AADF;AAGA;EACE,WAAA;EACA,YAAA;EACA,yBAAA;AADF","sourcesContent":[".box {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 3px;\n\n  border: none;\n  cursor: pointer;\n  height: 100%;\n  width: 100%;\n  background: none;\n  &:disabled {\n    cursor: default;\n  }\n}\n\n.tableBox {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n.smallImage {\n  max-width: 80px;\n  max-height: 60px;\n}\n.colorBox {\n  width: 80px;\n  height: 40px;\n  border: thin dotted black;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"box": `src-businessServices-services-bsBom2a-Bom2aControl-Bom2aPositions-Bom2aPositionsTable-components-Bom2aColorCell-Bom2aColorCell-module__box--i9cxZ`,
	"tableBox": `src-businessServices-services-bsBom2a-Bom2aControl-Bom2aPositions-Bom2aPositionsTable-components-Bom2aColorCell-Bom2aColorCell-module__tableBox--qp5nj`,
	"smallImage": `src-businessServices-services-bsBom2a-Bom2aControl-Bom2aPositions-Bom2aPositionsTable-components-Bom2aColorCell-Bom2aColorCell-module__smallImage--xjVCf`,
	"colorBox": `src-businessServices-services-bsBom2a-Bom2aControl-Bom2aPositions-Bom2aPositionsTable-components-Bom2aColorCell-Bom2aColorCell-module__colorBox--D7q8G`
};
export default ___CSS_LOADER_EXPORT___;
